import TotalSection from './TotalSection';

export default TotalSection;
